exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-3aaa1548] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n}\n.drawer-footer[data-v-3aaa1548] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 16px 24px;\n  background: #fff;\n  border-top: 1px solid #f0f0f0;\n  text-align: right;\n  z-index: 10;\n}\n.dialog-form[data-v-3aaa1548] {\n  max-height: 70vh;\n  overflow-y: auto;\n  padding-bottom: 40px;\n}\n", ""]);

// exports
